export enum remarkType {
    ORDER_SERVICE_DISPOSE = 23, // 服务单处理
    ORDER_TASK_DISPOSE = 33, // 任务处理备注
  }
